let data;
export default data = [
    {
        url1:"https://www.jefit.com/images/exercises/800_600/1156.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/1157.jpg",
        info:{
                Title:"Ankle Circles",
                group:"Main Muscle Group : Lower Legs",
                type:"Type : Strength",
                equip:"Equipment : Body Only"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/1148.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/1149.jpg",
        info:{
                Title:"Band Calf Raise",
                group:"Main Muscle Group : Lower Legs",
                type:"Type : Strength",
                equip:"Equipment : Bands"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/4920.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/4921.jpg",
        info:{
                Title:"Barbell Floor Calf Raise",
                group:"Main Muscle Group : Lower Legs",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/1188.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/1189.jpg",
        info:{
                Title:"Barbell Rocking Standing Calf Raise",
                group:"Main Muscle Group : Lower Legs",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/556.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/557.jpg",
        info:{
                Title:"Barbell Seated Calf Raise",
                group:"Main Muscle Group : Lower Legs",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/572.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/573.jpg",
        info:{
                Title:"Barbell Standing Calf Raise",
                group:"Main Muscle Group : Lower Legs",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/4944.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/4909.jpg",
        info:{
                Title:"Bodyweight Standing Calf Raise",
                group:"Main Muscle Group : Lower Legs",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        
    },
    {
        url1:"https://www.jefit.com/images/exercises/800_600/4908.jpg",
        url2:"https://www.jefit.com/images/exercises/800_600/4909.jpg",
        info:{
                Title:"Bodyweight Standing Calf Raise",
                group:"Main Muscle Group : Lower Legs",
                type:"Type : Strength",
                equip:"Equipment : Barbell"

            },
        button:"View History",
        bg:"#f4f4f4"
    },
    
    

]
